module.exports = __webpack_public_path__ + "img/morrison-pool.db7540cf.webp";